import { keyframes } from "@emotion/css";
import { Brightness } from "Shared/themes/Brightness";
import { Colour } from "Shared/themes/Colour";
import { ShowForegroundOnTimer } from "Shared/themes/ShowForegroundOnTimer";


export interface IAnimation {
	type: 'enable'|'enableOnce';
	options?: any;
	css?: any;
};

export interface IStylesRule {
	location: string[],
	css?: any,
	ignorePageMargins?: boolean,
	parallax?: boolean,
	border?;
	padding?;

	animations?: IAnimation[];
};

type Styles = {
	ui: XXX, //COMPONENT

	rules: (params:any) => {
		[name:string]: IStylesRule[]
	}
};


export function standardStyles(sizes,text): Styles
{
//TODO Probably better to have key/label pairs...
//XXX could have children to allow locations to specify sublocations. Probably better to implement eventually.
//XXX maybe support as 'posters:events' & 'posters:specials'
//XXX PROBABLY better done on a site basis... for the most part  TODO


	return {
/*				
		'No image margins on mobile': {
			rules: () => [{
				location: ['**','image'],
				noMarginsOnMobile: true
			}]
		},
*/				

		'Ignore page margins': {
			rules: () => [{
				location: ['*'],
				ignorePageMargins: true
			}]
		},
		'Parallax': {
			rules: () => [{
				location: ['*'],
				parallax: true
			}]
		},
		//TODO separate out standard styles so we dont have to explicity include them
		'Standard page headings': {
			rules: () => [{
				location: ['**','*:Page heading','**','text:title'],
				css: text.pageTitle
			}]
		},



		'Brightness': {
			ui: Brightness,

			rules: params => [{
				location: ['**','image'],

				css: { 
					filter: `brightness(${params.brightness}%)`
				},
			}]
		},

		'Background colour': {
			ui: Colour,

			rules: params => [{
				location: ['**'],

				css: { 
					background: params.colour,
					display: 'flex',
					height: '100%',
					margin: 0,
					padding: '.5em',
				},
			}]
		},

		'Overlay foreground background': {
			rules: () => [{
				location: ['**','overlay','foreground','*'],
				padding: {sides:'all',all:'2em'},
				css: {
					backgroundColor: 'rgba(0, 0, 0, 0.56)'
				}
			}]
		},
		
		//XXX modelled off The Townie club page. 
		'Narrow page': {
			rules: () => [{
				location: ['^','*'],
				css: {
					maxWidth: 820,
					marginLeft: 'auto',
					marginRight: 'auto',
				}
			}]
		},

		'Centre object': {
			rules: () => [{
				location: ['*'],
				css: {
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}
			}]
		},
	
		//XXX use in The Townie club page description. Should descriptions be left justified by default?
		'Left align': {
			rules: () => [{
				location: ['*'],
				css: {
					textAlign: 'left'
				}
			}]
		},

		'Footer grid': {
			rules: () => [{
				location: ['*'],
				css: {
					justifyItems: 'stretch',
					columnGap: 0,
					rowGap: 0,
					textAlign: 'left',
					

					title: {
						fontSize: '1em',
					},
					
					'> :nth-child(n)': {
						padding: '20px',
						margin: 0,
					},
				
					'> :first-child': {
						title: {
							fontSize: '1em',
						},
						borderStyle: 'solid none solid solid',
					},
					'> :nth-child(2)': {
						borderStyle: 'solid none solid none',
					},
					'> :nth-child(3)': {
						borderStyle: 'solid solid solid none',
					},
					'> :nth-child(4)': {
						borderStyle: 'solid solid solid none',
					},
					'> :nth-child(5)': {
						borderStyle: 'none none solid solid',
					},
					'> :nth-child(6)': {
						borderStyle: 'none none solid none',
					},
					'> :nth-child(7)': {
						borderStyle: 'none none solid solid',
					},
					'> :nth-child(8)': {
						borderStyle: 'none solid solid none',
					},

					[`@container (max-width:1000px)`]: {
						//safer to flip to one column sooner
						gridTemplateColumns: '1fr',
						gridTemplateRows: 'repeat(8)',

						'> :first-child': {
							borderStyle: 'solid none none none',
							padding: '20px 0 0 20px',
						},
						'> :nth-child(2)': {
							borderStyle: 'none',
						},
						'> :nth-child(3)': {
							borderStyle: 'none',
						},
						'> :nth-child(4)': {
							borderStyle: 'solid none',
						},
						'> :nth-child(5)': {
							borderStyle: 'none',					
						},
						'> :nth-child(6)': {
							borderStyle: 'none',
							padding: '0px 20px 20px 20px',
						},
						'> :nth-child(7)': {
							borderStyle: 'solid none none none',
						},
						'> :nth-child(8)': {
							borderStyle: 'none none solid none',
						},
					},

					[`@container (max-width:${sizes.flipToOneColumn}px)`]: {
						gridTemplateColumns: '1fr',
						gridTemplateRows: 'repeat(8)'
					},
				}
			}]
		},

		'Fade in': {
			rules: () => [{
				location: ['*'],

				css: {
					transition: 'opacity 1s',
					opacity: 0.1,
				},

				animations: [{
					type: 'enableOnce',
					options: {threshold: 0.3},
					css: {
						opacity: 1.0,
					}
				}]
			}]
		},

	
//TODO Ben please review/ remove unncessary settings, and consider making an editable parameter for 'transition' that defaults to 0.2 ease but can be increased or decreased. Ease in and out always looks better for hover

		'Fade in foreground on hover': {
			//XXX cf defaults
			rules: params => [{
				location: ['*'],

				css: { 
					[`@media (min-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {

							opacity: 0, //CJ added to hide foreground until hover. 0.2 ease slows the 'hide' when hover is taken away
							transition: 'opacity 1s',

							'&:hover': {
								animationName: 'unset',
								opacity: '1.0',
									transition: 'opacity 0.2s',
							}
						}
					},

					[`@media (max-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {
							opacity: 0.1,
							transition: 'opacity 0.2s',
						}
					},
				},

				animations: [{
					type: 'enable',
					options: {threshold: 0.6},
					css: {
						[`@media (max-width:${sizes.flipToOneColumn}px)`]: {
							'> :nth-child(2)': {
								opacity: 1.0,
								transition: 'opacity 0.5s',
							}
						}
					}
				}]
			}]
		},


		///

		'Show foreground on timer': {
			ui: ShowForegroundOnTimer,
			//XXX cf defaults

			rules: params => [{
				location: ['*'],

				css: { 
					'> :nth-child(2)': {
						transition: 'opacity 1s',
					},

					[`@container (min-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {
							...timedFades(params.groupSize,params.cycleTime,params.startingPosition),

							//HACK hover causes the animation to reset so if there are a group of items they will no longer
							//     be coordinated. I believe you can have multiple animations a once. Consider try setting a second
							//     animation on hover...
							'&:hover': {
								animationName: 'unset',
								opacity: '1.0',
							}
						}
					},

					[`@container (max-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {
							opacity: 0.1,
						}
					},
				},

				animations: [{
					type: 'enable',
					options: {threshold: 0.8},
					css: {
						[`@container (max-width:${sizes.flipToOneColumn}px)`]: {
							'> :nth-child(2)': {
								opacity: 1.0,
							}
						}
					}
				}]
			}]
		},

		/* Examples:

		'Orange features': {
			rules: () => [{
				location: ['**','*:Featured','**','text'],
				css: {
					border: 'solid 10px orange'
				}
			}]
		},
		'Pink special pages': {
			rules: () => [{
				location: ['^:Special page'],
				css: {
					backgroundColor: 'pink'
				}
			}]
		}
		*/
	};
}

/* startingPosition starts at 1 */
function timedFades(groupSize:number,itemCycleTime/*secs*/:number,startingPosition:number)
{
	const startPos = startingPosition - 1;

//		` + ` ${groupSize * itemCycleTime}s infinite`,
	return {
		animation: keyframes`
			0%  { opacity: 0; }  
			${20/groupSize}% { opacity: 1; } 
			${80/groupSize}% { opacity: 1; } 
			${100/groupSize}% { opacity: 0; }  
			100% { opacity: 0; }  
		` + ` ${groupSize * itemCycleTime}s infinite`,
		animationDelay: (itemCycleTime * startPos) + 's',
	};
}

